import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { takeUntil } from 'rxjs';
import { BaseResizableComponent } from '@src/app/modules/base';
import { InputItemType } from '@src/app/modules/search-cities';

import { LoyaltyProgramReadService, LpSimilarProductsStoreService } from '../../../services';
import { LoyaltyProgramProduct } from '../../../models';

@Component({
  selector: 'lp-similar-products',
  templateUrl: './similar-products.component.html',
  styleUrls: ['./similar-products.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimilarProductsComponent extends BaseResizableComponent implements OnInit, OnChanges {
  private readonly loyaltyProgramReadService = inject(LoyaltyProgramReadService);
  private readonly lpSimilarProductsStore = inject(LpSimilarProductsStoreService);

  @Input() productId?: string;
  @Input() unionId?: string;
  @Input() city?: InputItemType | null;

  products?: LoyaltyProgramProduct[];

  ngOnInit(): void {
    this.lpSimilarProductsStore.data$.pipe(takeUntil(this.destroyed$$)).subscribe(() => {
      if (this.productId) {
        this.products = this.lpSimilarProductsStore.getData(this.productId);
        this.cdr.markForCheck();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.productId && this.productId) {
      this.loyaltyProgramReadService.getSimilarProducts(this.productId, this.unionId, this.city?.cityId);
    }
  }
}
